import React from 'react';
import trans from 'translate';
import { openJoinPoolModal, openModal } from 'redux/actions/modalActions';
import { createNotificationAction } from '../../../../../redux/actions/uiActions';
import configJson from '../../../../../config/config.json';
import { compareSearch } from '../../../../Common/TxFinder/TxFinder';
import { GET_WHITELISTED_MODAL, PARTICIPATION_MODAL } from '../../../../Modals/modalTypes';
import { mockWhitelistedWallets } from '../../../../../constants/createHPool';
import { isNotUndefiend } from '../../../../../utils/validation';
import {
  renderedRecords,
  vpoolRenderedRecords,
} from '../../../HPool/HpoolComponents/PhaseStatus/RenderedRecords/RenderedRecords';
import { formatNumericValues } from '../../../../../utils/format';
import { deductFeeValue } from '../../../../../services/utilsService';

const subscriptionMethod = ({ dispatch, hpool, subscriptionType, refreshPools, hasError }) => {
  if (hasError) {
    dispatch(createNotificationAction('error', hasError.msg, 3000));
    return;
  }
  dispatch(openJoinPoolModal({ hpoolWeb3Id: hpool.web3_hpool_id, subscriptionType, refreshPools, hpool }));
};

const t = (msg) => trans(msg, false, false, false);

const hasAStrikt = { renderLabel: (msg) => `*${t(msg)}`, style: { color: 'var(--champion-legend-ticket-sale)' } };

export const CANT_VIEW_STATUSES = ['PENDING_INIT', 'PENDING_CHAMPION_DEPOSIT'];
export const canViewPool = ({ isMine, status }) =>
  isMine || !CANT_VIEW_STATUSES.find((noViewStatus) => status === noViewStatus);

export const PRIVATE_SUBSCRIPTION = 'PRIVATE_SUBSCRIPTION';
export const ACTIVE_STATUS = 'ACTIVE';
export const ENDED_STATUS = 'ENDED';

export const defaultRenderedStats = [
  { prop: 'launchDate', title: 'reation_date' },
  { prop: 'reserved', title: 'reserved', render: ({ from, to }) => `${from}/${to}` },
  { prop: 'capacityInUsd', title: 'deposits', render: (cap) => `$${cap}` },
  { prop: 'numberOfSubscribers', title: 'subscribers' },
];

export const sharedStatues = {
  DRAFT: {
    title: 'hpool.draft',
    color: 'var(--champion-legend-deposit)',
    tooltipTitle: 'champion.legend_tooltip_deposit_title',
    tooltipText: 'champion.legend_tooltip_deposit',
    willLinkTo: '/create-pool/choose-tokens',
  },
  PENDING_CHAMPION_DEPOSIT: {
    title: (isVpool) => (isVpool ? 'pools.desc_6_title' : 'hpool.deposit_funds'),
    color: 'var(--champion-legend-deposit)',
    tooltipTitle: 'champion.legend_tooltip_deposit_title',
    tooltipText: 'champion.legend_tooltip_deposit',
    btnTitle: 'hpool.add_funds',
    onClick: ({ push, hpool }) => push(`/hpool/${hpool.id}`),
    willLinkTo: (isVpool) => isVpool && '/create-pool/deposit-funds',
  },
  PENDING_INIT: {
    title: 'hpool.creating',
    color: 'var(--champion-legend-creating)',
    tooltipTitle: 'champion.legend_tooltip_creating_title',
    tooltipText: 'champion.legend_tooltip_creating',
    bottomParagraph: 'hpool.creating_footer_text',
    hideMetrics: true,
    showNextStage: true,
    stepIndex: 1,
  },
  SUBSCRIPTION_FAILED: {
    title: 'hpool.subscribtion_failed',
    color: 'var(--champion-legend-subscribtion-failed)',
    tooltipTitle: 'champion.legend_tooltip_subscription_failed_title',
    tooltipText: 'champion.legend_tooltip_subscription_failed',
    percentage: 100,
  },
  INIT_FAILED: {
    title: 'hpool.creation_failed',
    color: 'var(--champion-legend-subscribtion-failed)',
    tooltipTitle: 'champion.legend_tooltip_ended_title',
    tooltipText: 'champion.legend_tooltip_ended',
    percentage: 100,
  },
  LAUNCH_FAILED: {
    title: 'hpool.launch_failed',
    color: 'var(--champion-legend-subscribtion-failed)',
    tooltipTitle: 'champion.legend_tooltip_ended_title',
    tooltipText: 'champion.legend_tooltip_ended',
    percentage: 100,
  },
  ASSET_TRANSITION_PENDING: {
    vpoolStep: 1, // mapped to subscribtion
    title: 'hpool.deploying',
    color: 'var(--champion-legend-deploying)',
    tooltipTitle: 'champion.legend_tooltip_deploying_title',
    tooltipText: 'champion.legend_tooltip_deploying',
  },
  ASSET_STATE_TRANSITION_IN_PROGRESS: {
    title: 'hpool.deploying',
    color: 'var(--champion-legend-deploying)',
    tooltipTitle: 'champion.legend_tooltip_deploying_title',
    tooltipText: 'champion.legend_tooltip_deploying',
  },
  ASSET_STATE_TRANSITION_PENDING: {
    title: 'hpool.deploying',
    color: 'var(--champion-legend-deploying)',
    tooltipTitle: 'champion.legend_tooltip_updating_title',
    tooltipText: 'champion.legend_tooltip_updating',
    percentage: 80,
  },
  ASSET_STATE_TRANSITION_FAILED: {
    title: 'hpool.state_transition_failed',
    color: 'var(--champion-legend-subscribtion-failed)',
    tooltipTitle: 'champion.legend_tooltip_ended_title',
    tooltipText: 'champion.legend_tooltip_ended',
    percentage: 100,
  },
  LAUNCH: {
    title: 'hpool.deploying',
    color: 'var(--champion-legend-deploying)',
    tooltipTitle: 'champion.legend_tooltip_deploying_title',
    tooltipText: 'champion.legend_tooltip_deploying',
  },
};

export const hpoolStatusSrc = {
  TICKET_SALE: {
    title: 'hpool.ticket_sale',
    vpoolStep: 0, // mapped to whitlist
    color: 'var(--champion-legend-ticket-sale)',
    tooltipTitle: 'champion.legend_tooltip_ticket_sale_title',
    tooltipText: 'champion.legend_tooltip_ticket_sale',
    btnTitle: 'hpool.get_tickets',
    onClick: ({ push, hpool }) => push(`/hpool/${hpool.id}`),
    showNextStage: true,
    showTimeEnded: true,
    stepIndex: 2,
    showDefaultStats: true,
    renderedStats: [
      { prop: 'launchDate', title: 'reation_date' },
      {
        prop: 'ownedTickets',
        title: 'owned',
        ...hasAStrikt,
      },
      {
        prop: 'totalHordStaked',
        title: 'current_staking',
        ...hasAStrikt,
      },
    ],
  },
  PRIVATE_SUBSCRIPTION: {
    // decrease period of it
    vpoolStep: 0, // mapped to whitlist but with ended
    title: 'hpool.private_subscribtion',
    color: 'var(--champion-legend-darker-subscription)',
    tooltipTitle: 'champion.legend_tooltip_subscription_title',
    tooltipText: 'champion.legend_tooltip_subscription',
    btnTitle: 'hpool.subscribe_btn',
    stepIndex: 3,
    onClick: (tileInfo) => subscriptionMethod({ ...tileInfo, subscriptionType: 'private' }),
    disableConditions: ({ totalTikcetsMinted, isSubscribed, hpool, championId }) => [
      { condition: hpool?.champion_id === championId, msg: 'You cannot subscribe to your own pool' },
      { condition: !+totalTikcetsMinted, msg: 'You must have tickets to subscribe in this round' },
      { condition: isSubscribed, msg: 'You already subscribed in this pool' },
    ],
    renderedStats: [
      { prop: 'launchDate', title: 'reation_date' },
      { prop: 'reserved', title: 'reserved', render: ({ from, to }) => `${from}/${to}` },
      { prop: 'capacityInUsd', title: 'deposits', render: (cap) => `$${cap}` },
      { prop: 'numberOfSubscribers', title: 'subscribers' },
      {
        prop: 'ownedTickets',
        title: 'owned',
        ...hasAStrikt,
      },
      {
        prop: 'champInitDepo',
        title: 'init_deposit',
        render: (value) => `${value} ${configJson.baseCoin}`,
        ...hasAStrikt,
      },
    ],
    showNextStage: true,
    showTimeEnded: true,
    contractMethod: 'privateSubscribeForHPool',
  },
  PUBLIC_SUBSCRIPTION: {
    vpoolStep: 1, // mapped to subscribtion
    title: 'hpool.public_subscribtion',
    color: 'var(--champion-legend-subscription)',
    tooltipTitle: 'champion.legend_tooltip_subscription_title',
    tooltipText: 'champion.legend_tooltip_subscription',
    btnTitle: 'hpool.subscribe_btn',
    onClick: (tileInfo) => subscriptionMethod({ ...tileInfo, subscriptionType: 'public' }),
    disableMsg: 'This process requires tickets to complete',
    disableConditions: ({ isSubscribed, hpool, championId, championAddress, account }) => [
      { condition: compareSearch(championAddress, account), msg: 'You cannot subscribe to your own pool' },
      { condition: isSubscribed, msg: 'You already subscribed in this pool' },
    ],
    renderedStats: [
      { prop: 'launchDate', title: 'reation_date' },
      { prop: 'reserved', title: 'reserved', render: ({ from, to }) => `${from}/${to}` },
      { prop: 'capacityInUsd', title: 'deposits', render: (cap) => `$${cap}` },
      { prop: 'numberOfSubscribers', title: 'subscribers' },
      {
        prop: 'ownedTickets',
        title: 'owned',
        ...hasAStrikt,
      },
      {
        prop: 'champInitDepo',
        title: 'init_deposit',
        render: (value) => `${value} ${configJson.baseCoin}`,
        ...hasAStrikt,
      },
    ],
    showNextStage: true,
    showTimeEnded: true,
    stepIndex: 4,
    contractMethod: 'publicSubscribeForHPool',
  },
  ACTIVE: {
    vpoolStep: 2, // mapped to live and traded
    title: 'hpool.live',
    percentage: 100,
    color: 'var(--champion-legend-live)',
    tooltipTitle: 'champion.legend_tooltip_live_title',
    tooltipText: 'champion.legend_tooltip_live',
    btnTitle: ({ userTotalPoolTokens }) => (userTotalPoolTokens ? 'hpool.trade_tokens' : 'hpool.get_more_pool_tokens'),
    onClick: ({ hpool }) => window.open(`${configJson.dexUrl}/${hpool.contract_address}`, '_blank'),
    alwaysClickable: true,
    stepIndex: 5,
    renderedStats: [
      { prop: 'launchDate', title: 'reation_date' },
      { prop: 'tokenPrice', title: 'token_price', render: (value) => `$${value}` },
      { prop: 'numberOfSubscribers', title: 'subscribers' },
      {
        prop: 'coinsAndTags',
        renderLabel: () => <></>,
      },
      {
        prop: 'formattedCapacity',
        renderLabel: () => <></>,
        render: (value) => <span className="total-cap">{`$${value}`}</span>,
      },
    ],
  },
  FINISHING: {
    title: 'hpool.finishing',
    color: 'var(--champion-legend-ending)',
    tooltipTitle: 'champion.legend_tooltip_ending_title',
    tooltipText: 'champion.legend_tooltip_ending',
  },
  ENDED: {
    title: 'hpool.ended',
    color: 'var(--champion-legend-ended)',
    tooltipTitle: 'champion.legend_tooltip_ended_title',
    tooltipText: 'champion.legend_tooltip_ended',
    btnTitle: 'hpool.redeem',
    onClick: ({ push, hpool }) => push(`/hpool/${hpool.id}`),
    percentage: 100,
  },
};

const vpoolRenderedStats = [
  { prop: 'launchDate', title: 'reation_date' },
  { prop: 'minParticipationUsd', title: 'min_participation', render: (min) => `$${formatNumericValues(min)}` },
  { prop: 'maxParticipationUsd', title: 'max_participation', render: (max) => `$${formatNumericValues(max)}` },
  {
    prop: 'fundsCollected',
    title: 'funds_collected',
    render: (fundsCollected = '0') => `$${formatNumericValues(fundsCollected || '0', true)}`,
  },
  {
    prop: 'maxPoolAllocationInUsd',
    title: 'max_pool_size',
    render: (maxPoolAllocationInUsd) => `$${formatNumericValues(maxPoolAllocationInUsd)}`,
  },
];

export const vpoolStatusesSrc = {
  WHITELIST: {
    title: 'hpool.whitelisting',
    color: 'var(--vpool-whitelist)',
    showNextStage: true,
    showTimeEnded: true,
    stepIndex: 2,
    tooltipTitle: 'vpool.legend_tooltip_whitelisting_title',
    tooltipText: 'vpool.legend_tooltip_whitelisting',
    btnTitle: 'hpool.get_whitelisted',
    phaseDescription: 'vpool.viking_dao_whitelist_description',
    disableConditions: ({
      whitelistedPool,
      hpool: { id },
      championId,
      account,
      championAddress,
      busdBalance,
      poolOwnerId,
    }) => [
      {
        condition: compareSearch(championAddress, account) || compareSearch(championId, poolOwnerId),
        msg: 'You cannot apply for whitelising for your own pool',
      },
      { condition: whitelistedPool.includes(id), msg: 'You have already been whitelisted' },
      // { condition: busdBalance < 100, msg: 'You must have at least 100 BUSD in your wallet to apply for whitelisting' },
    ],
    onClick: ({ dispatch, hpool }) => dispatch(openModal(GET_WHITELISTED_MODAL, { poolId: hpool.id })),
    renderedStats: vpoolRenderedStats,
  },
  SUBSCRIPTION_PHASE: {
    ...hpoolStatusSrc.PUBLIC_SUBSCRIPTION, // we'll use almost the same functionality and props from PUBLIC_SUBSCRIPTION but with couple updates
    title: 'vpool.participation',
    tooltipTitle: 'vpool.participation',
    tooltipText: 'vpool.legend_tooltip_participation_text',
    stepIndex: 3,
    color: 'var(--vpool-participation)',
    btnTitle: 'hpool.subscribe_btn',
    phaseDescription: 'vpool.viking_dao_participation_description',
    onClick: ({ dispatch, hpool, push }) => {
      push(`/hpool/${hpool.id}`);
      dispatch(openModal(PARTICIPATION_MODAL, { poolId: hpool.id }));
    },
    disableConditions: ({
      whitelistedPool,
      hpool: { id, web3_hpool_id: web3Id, ...rest },
      timeLeftPercentage,
      subscribedVPools = [],
      championAddress,
      championId,
      poolOwnerId,
      account,
    }) => [
      {
        condition: compareSearch(championId, poolOwnerId) || compareSearch(championAddress, account),
        msg: 'You cannot subscribe to your own pool',
      },
      // { condition: subscribedVPools?.includes?.(`${web3Id}`), msg: 'You already subscribed in this pool' }, // user should be whitelisted to be able to participate
    ],
    renderedStats: vpoolRenderedStats,
  },
  ACTIVE: {
    stepIndex: 4,
    title: 'vpool.live',
    tooltipTitle: 'vpool.live_tooltip_title',
    tooltipText: 'vpool.live_tooltip_text',
    color: 'var(--vpool-live)',
    phaseDescription: 'vpool.viking_dao_live_description',
    renderedStats: vpoolRenderedStats,
  },
};

export const getStatusPercentage = (status) => {
  const statusKeys = Object.keys(hpoolStatusSrc);
  const statusOrderInMapper = statusKeys.findIndex((key) => key === status);
  return hpoolStatusSrc?.[status]?.percentage || 0;
};

const renderedStatuses = { ...hpoolStatusSrc, ...vpoolStatusesSrc };

export const statusLength = Math.max(
  ...Object.values(renderedStatuses)
    .map((status) => status.stepIndex)
    .filter((value) => value),
);

const updateStepInfo = (statusSrc, statusProps) => {
  const stepIndexesArray = Object.values(statusSrc)
    .map((statusObj) => statusObj.stepIndex)
    .filter(isNotUndefiend);
  const totalStatusLength = Math.max(...stepIndexesArray);
  const mergedWithTotalStatusLength = { ...statusProps, statusLength: totalStatusLength };
  return mergedWithTotalStatusLength;
};

const mergedStatusSrc = {
  vpool: {
    phaseStatusProps: vpoolRenderedRecords,
    statusSrc: vpoolStatusesSrc,
    defaultStats: vpoolRenderedStats,
  },
  hpool: {
    phaseStatusProps: renderedRecords,
    statusSrc: hpoolStatusSrc,
    defaultStats: defaultRenderedStats,
  },
};

export const getPoolStatusInfo = (status, isVpool) => {
  const statusSrcKey = isVpool ? 'vpool' : 'hpool';
  const { phaseStatusProps } = mergedStatusSrc?.[statusSrcKey]; // That where u get the records rendered in PhaseStatus component

  const { defaultStats } = mergedStatusSrc?.[statusSrcKey];
  let { statusSrc } = mergedStatusSrc?.[statusSrcKey]; // That where u get the general info of status (color, title, rendered stats, ...etc)
  statusSrc = { ...statusSrc, ...sharedStatues }; // Merged with shared statuses

  let statusProps = statusSrc?.[status];
  statusProps = updateStepInfo(statusSrc, statusProps); // Merged with step index info

  statusProps.renderedStats = statusProps.renderedStats || defaultStats;

  return { statusProps, phaseStatusProps } || {};
};

export const getPoolStatusProps = (status, isVpool) => {
  const { statusProps } = getPoolStatusInfo(status, isVpool) || {};
  return statusProps;
};

export const getPoolPhaseStatusInfo = (status, isVpool) => {
  const { phaseStatusProps } = getPoolStatusInfo(status, isVpool) || {};
  return phaseStatusProps;
};
